/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { TemplateResult, html } from 'lit';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import C4DContentBlock from '../content-block/content-block';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import styles from './content-group.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * Content group.
 *
 * @abstract
 */
@customElement(`${c4dPrefix}-content-group`)
class C4DContentGroup extends StableSelectorMixin(C4DContentBlock) {
  protected _renderInnerBody(): TemplateResult | string | void {
    return html` ${this._renderMedia()}${this._renderContent()} `;
  }

  static get stableSelector() {
    return `${c4dPrefix}--content-group`;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DContentGroup;
